import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { FaToggleOff, FaToggleOn } from "react-icons/fa";
import Tooltip from "./Tooltip/Tooltip";
import { IoIosInformationCircleOutline } from "react-icons/io";

const ToggleRightField = ({
  text,
  name,
  value,
  subtext,
  tooltip,
  border,
  Nohover,
  padding,
  subtextoption,
  disabled
}) => {
    const { setFieldValue } = useFormikContext();

  const [toggle, setToggle] = useState(value);

  const handleClick = (name) => {
    setToggle(!toggle);
    console.log(name,!toggle);
    
    toggle ? setFieldValue(name, false) : setFieldValue(name, true);
  };

  // console.log('value',value);

  useEffect(()=>{
    setToggle(value)
  },[value])
  

  return (
    <div
      className={`text-sm   w-full ${padding ? "" : "py-3"} ${
        border ? "" : "border-b"
      }`}
    >
      <div className="flex justify-between items-center">
        <div className="flex">
        <div>{text}</div>
        {tooltip?(<Tooltip text={tooltip} size={16} className="mb-2 cursor-pointer"><IoIosInformationCircleOutline /></Tooltip>):""}
        </div>
        <div className="flex justify-between gap-40">
          {subtextoption ? <div>{subtext}</div> : ""}
          <span onClick={()=>!disabled && handleClick(name)} className="cursor-pointer">
            {toggle ? (
              <FaToggleOn
                className={`text-xl ${Nohover?"text-[#6B7280]":"hover:text-hoverColor "} `}
                id="toggle"
              />
            ) : (
              <FaToggleOff
                className={` text-xl ${Nohover?"text-[#6B7280]":"hover:text-hoverColor"} `}
                id="toggle"
              />
            )}
          </span>
        </div>
      </div>
      {subtextoption ? "" : <div className="text-[11px]">{subtext}</div>}
    </div>
  );
};

export default ToggleRightField;
